const images = [
  {
    src: 'https://picsum.photos/id/25/600/400',
    description: 'Sun shining through the trees'
  },
  {
    src: 'https://picsum.photos/id/35/600/400',
    description: 'Sun shining on a cactus'
  },
  {
    src: 'https://picsum.photos/id/13/600/400',
    description: 'Rocky beach with drift wood and trees'
  },
  {
    src: 'https://picsum.photos/id/29/600/400',
    description: 'Arid mountains with small clouds'
  },
  {
    src: 'https://picsum.photos/id/49/600/400',
    description: 'Greek city on the coast with white buildings'
  }
];

export default images;
